export default "__VITE_ASSET__DSIK4vGS__"